import { SagaIterator } from "redux-saga";
import { all, fork } from "redux-saga/effects";

import { agentsViewSagas } from "./agents/sagas";
import { instructionsModalViewSagas } from "./forwarding-instructions/sagas";
import { fullscreenWidgetsViewSagas } from "./fullscreen-widgets/sagas";
import { invoicesViewSagas } from "./invoices/sagas";
import reportsViewSagas from "./reports/sagas";
import { settingsViewSagas } from "./settings/sagas";
import { subscriptionViewSagas } from "./subscription/sagas";
import { teamsViewSagas } from "./teams/sagas";
import { ticketsViewSagas } from "./tickets/sagas";
import { welcomeTutorialViewSagas } from "./welcome-tutorial/sagas";

export function* viewSagas(): SagaIterator {
  yield all([
    fork(agentsViewSagas),
    fork(teamsViewSagas),
    fork(ticketsViewSagas),
    fork(settingsViewSagas),
    fork(subscriptionViewSagas),
    fork(invoicesViewSagas),
    fork(reportsViewSagas),
    fork(welcomeTutorialViewSagas),
    fork(instructionsModalViewSagas),
    fork(fullscreenWidgetsViewSagas),
  ]);
}
